import React, { useState } from "react";
import { Button, Icon, SystemMessage, Tooltip } from "@shoptet/ui";
import {
  AdminMetaAdsOrganizationsDocumentT,
  useAdminCancelMetaPageClaimRequestMutation,
} from "../../graphql/generated/graphql";
import { ModalWrapper } from "../ModalWrapper";

type CancelMetaPageClaimButtonPropsT = {
  apiToken: string;
};

const CancelMetaPageClaim = ({ apiToken, onClose }: CancelMetaPageClaimButtonPropsT & { onClose: () => void }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [cancel, { loading }] = useAdminCancelMetaPageClaimRequestMutation({
    refetchQueries: [AdminMetaAdsOrganizationsDocumentT],
    awaitRefetchQueries: true,
    onCompleted(data) {
      const payload = data.adminCancelMetaPageClaimRequest;
      if (payload?.success) {
        onClose();
      } else {
        setErrorMessage(payload?.errors?.[0] ?? "Mutation failed");
      }
    },
    onError(error) {
      setErrorMessage(error.message);
    },
  });

  const handleCancel = () => {
    setErrorMessage(null);
    cancel({
      context: {
        headers: {
          Authorization: `ApiToken ${apiToken}`,
        },
      },
    });
  };

  return (
    <div>
      <p>
        Tímto vynulujeme stav claim requestu (datum požadavku i důvod selhání) a nový request neodešleme. Použij pouze
        pokud jsi pending request smazal přímo v Meta Business Manageru.
      </p>
      {errorMessage && <SystemMessage description={errorMessage} level="error" />}
      <Button disabled={loading} variant="action" onClick={handleCancel}>
        {loading ? "Ruším..." : "Zrušit claim request"}
      </Button>
    </div>
  );
};

export const CancelMetaPageClaimButton = ({ apiToken }: CancelMetaPageClaimButtonPropsT) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Tooltip closeDelay={300} content="Zrušení zaslané žádosti (po zrušení žádosti v Metě)">
        <span style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
          <Icon icon="shp-cross" variant="secondary" />
        </span>
      </Tooltip>

      <ModalWrapper isOpen={isOpen} title="Zrušit Meta page claim request" onClose={() => setOpen(false)}>
        {isOpen && <CancelMetaPageClaim apiToken={apiToken} onClose={() => setOpen(false)} />}
      </ModalWrapper>
    </>
  );
};
